import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  max-height: 50vh;
  overflow-y: auto;

  & > * {
    flex-shrink: 0;
  }
`

export const FileRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
